import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import HomePage from "./pages/HomePage";
import Header from "./components/Header";
import Cart from "./components/Cart";
import Wishlist from "./components/Wishlist";
import SingleProduct from "./components/SingleProduct";
import SingleProductAcc from "./components/SingleProductAcc";
import Category from "./components/Category";
import Footer from "./components/Footer";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import ServicePricesView from "./pages/ServicePricesView";
import ServiceStatusView from "./pages/ServiceStatusView";
import PhoneFinderAssistant from "./components/PhoneFinderAssistant";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DataDeletion from "./pages/DataDeletion";
import TermsOfService from "./pages/TermsOfService";
import { trackPageView } from "./utils/analytics";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  const location = useLocation();

  useEffect(() => {
    const pagePath =
      location.pathname === "/status" ? location.pathname : `${location.pathname}${location.search}`;

    trackPageView({
      path: pagePath,
      title: document.title,
    });
  }, [location.pathname, location.search]);

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/cart" element={<Cart />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/telefon/:slug" element={<SingleProduct />} />
        <Route path="/product/:productId" element={<SingleProduct />} />{" "}
        <Route
          path="/product/accessories/:productId"
          element={<SingleProductAcc />}
        />
        <Route path="/dodatok/:slug" element={<SingleProductAcc />} />{" "}
        <Route path="/telefoni/:category" element={<Category />} />
        <Route path="/galanterija/:category" element={<Category />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/servis" element={<ServicePricesView />} />
        <Route path="/service" element={<ServicePricesView />} />
        <Route path="/status" element={<ServiceStatusView />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/data-deletion" element={<DataDeletion />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        {/* nagradna igra ruti */}
        {/* <Route path="/winner/ZGlzYzEw" element={<Price discount={10} />} />
        <Route path="/winner/ZGlzYzIw" element={<Price discount={20} />} />
        <Route path="/winner/ZGlzYzMw" element={<Price discount={0} />} /> */}
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      {location.pathname === "/" ? <PhoneFinderAssistant /> : null}
    </>
  );
}

export default App;
